module.exports = __webpack_public_path__ + "static/media/dam.a2a36d82.jpg";